<!--
  Bone.svelte — one grey shape in a Store page skeleton.

  Every skeleton in this folder is built from these, so the bars share one colour and one radius —
  gray-300/700, visible at every `bg-depth` level.

  Sizes are passed as **whole Tailwind classes** (`h-4 w-1/2`), never assembled from parts: a class
  built at runtime is invisible to the JIT scanner and silently never ships.
-->
<script lang="ts">
	interface Props {
		/** Size classes, written out whole (`h-3 w-full`). */
		class?: string;
		/** A circle or a square tile rather than a bar. */
		round?: 'full' | 'xl';
	}

	let { class: className = 'h-3 w-full', round = 'full' }: Props = $props();
</script>

<div class="{className} bg-gray-300 dark:bg-gray-700 {round === 'full' ? 'rounded-full' : 'rounded-xl'}"></div>
